import { BILLING_INTERVAL } from "@/data/constants";
import { TProductPricing } from "@/types/plan";
import { TBillingInterval } from "@/types/app";
import { getIntervalListPrice } from "./billingInterval";

/**
 * Picks the list price matching the billing interval, e.g. `60` for yearly.
 *
 * Returns a raw number — no currency formatting (see `formatAmount`) — and
 * always the list price, so any `discounted*` fields on the pricing are ignored.
 */
export const formatPriceForBilling = (
  pricing: TProductPricing,
  billing: TBillingInterval = BILLING_INTERVAL.YEARLY,
) => getIntervalListPrice(pricing, billing);
